import { Center, Paper, Tabs, Title } from "@mantine/core";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { userTypes } from "../../AdminPages/Users/userTypes";
import { LoaderWrapper } from "../../components/LoaderWrapper";

import JobSeekersIFollow from "../jobseeker/JobSeekersIFollow";
import { loadJobSeekerFollowers } from "../jobseeker/loadData";
import CompaniesIFollow from "./CompaniesIFollow";

const ConnectionCompanies = () => {
  const [loading, setLoading] = useState(true);
  const [followers, setFollowers] = useState([]);
  const [refresh, setRefresh] = useState(false);

  console.log(":", followers);
  useEffect(() => {
    loadJobSeekerFollowers(setLoading).then(setFollowers);
  }, [refresh]);
  return (
    <Tabs
      defaultValue="following"
      color={"red.9"}
      styles={{
        tabLabel: {
          fontSize: "1rem",
        },
      }}
    >
      <Tabs.List>
        <Tabs.Tab value="following">Following</Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="following" pt="xs">
        <Paper bg={"transparent"}>
          <LoaderWrapper loading={loading}>
            {followers.filter((follower) => {
              if (follower.role === userTypes.Companies) {
                return true;
              }
            }).length > 0 ? (
              <CompaniesIFollow
                followers={followers}
                refresh={refresh}
                setRefresh={setRefresh}
                setLoading={setLoading}
              />
            ) : (
              <Center position="center">
                <Title order={1}>
                  You currently are not following any companies
                </Title>
              </Center>
            )}
          </LoaderWrapper>
        </Paper>
      </Tabs.Panel>
    </Tabs>
  );
};

export default ConnectionCompanies;
